import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { DataserviceService } from '../dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-update-rep-modal',
  templateUrl: './update-rep-modal.component.html',
  styleUrl: './update-rep-modal.component.css'
})
export class UpdateRepModalComponent {

  currentUser: any;
  repForm: FormGroup
  distributors: any;
  companies: any;
  users: any;
  wo: any;
  unassignedData: any;

  dLoading: boolean = false;
  cLoading: boolean = false;
  rLoading: boolean = false;

  saving: boolean = false;

  constructor(
    @Inject(NZ_MODAL_DATA) private data: any,
    private dataService: DataserviceService,
    private modalRef: NzModalRef,
    private nzNotify: NzNotificationService
  ) {

    this.repForm = new FormGroup({
      'rep': new FormControl(null),
      'company': new FormControl(null),
      'distributor': new FormControl(null, [Validators.required])
    })

  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.wo = this.data?.wo;
    this.unassignedData = this.data?.unassignedData;


    this.repForm.patchValue({
      'rep': this.data?.rep,
      'company': this.data?.company,
      'distributor': this.data?.distributor,
    });

    if(this.hasPermission('view_all_users')) {
      this.dLoading = true;
      this.cLoading = true;
      this.rLoading = true;

      this.getDistributors();
      this.getCompaniesByDistributor();
      this.getUsersByCompany();
    }else if(this.hasPermission('view_distributor_users')) {
      this.cLoading = true;
      this.rLoading = true;

      this.getCompaniesByDistributor();
      this.getUsersByCompany();
    }else {
      this.rLoading = true;
      
      this.getUsersByCompany();
    }

  }

  getDistributors() {
    this.dataService.getData('distributors')
      .subscribe({
        next: (res: any) => {
          this.distributors = res?.data;
          this.dLoading = false;
        },
        error: (err: any) => {
          console.log('err from getDistributors: ', err)
        }
      })
  }

  getCompaniesByDistributor() {
    this.dataService.getData(`company/companies-by-distributor/${this.repForm?.value?.distributor}`)
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
          this.cLoading = false;
        },
        error: (err: any) => {
          console.log('error on get companies by distributor: ', err)
        }
      });
  }

  getUsersByCompany() {
    this.dataService.getData(`users/companyUsers/${this.repForm?.value?.company}`)
      .subscribe({
        next: (res: any) => {
          this.users = res;
          this.rLoading = false;
        }
      })
  }

  hasPermission(permission: string): boolean {
    if (this.currentUser.super_admin) {
      return true;
    }
    return this.currentUser.permissions?.some((p: any) => p.name === permission) ?? false;
  }

  save() {
    if(this.repForm.valid) {
      this.saving = true;
      let obj = {
        id: this.wo.id,
        user_id: this.repForm.get('rep')?.value,
        company_id: this.repForm.get('company')?.value,
        distributor_id: this.repForm.get('distributor')?.value,
        temp_rep_name: this.data?.unassignedData?.temp_rep_name || null
      }
      this.dataService.postData(obj, `work-order/update-user`)
        .subscribe({
          next: (res: any) => {
            this.successNotification();
            this.saving = false;
            this.modalRef.close(res)
          },
          error: (err: any) => {
            this.errorNotification();
            this.saving = false;
          }
        })
    }else {
      this.nzNotify.create(
        'warning',
        'Warning!',
        `Please select a rep to continue`,
        { nzPlacement: 'top' }
      );
    }
  }

  cancel() {
    this.modalRef.close();
  }

  successNotification() {
    this.nzNotify.create(
      'success',
      'Success!',
      `Rep has been updated`,
      { nzPlacement: 'top' }
    );
  }

  errorNotification() {
    this.nzNotify.create(
      'error',
      'Error!',
      'Failed to update rep!',
      { nzPlacement: 'top' }
    );
  }

}
